import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrainingDateComponent } from './training-date.component';

const routes: Routes = [{ path: '', component: TrainingDateComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrainingDateRoutingModule {}
